import { Box } from "@mui/material";

import NavbarDesktop from "src/components/home/Navbar/NavbarDesktop";
import NavbarMobile from "src/components/home/Navbar/NavbarMobile";

const Navbar = ({ position = "fixed" }) => {
	const isMobile = localStorage.getItem("isMobile");

	return (
		<>
			<Box sx={{ display: { xs: "none", lg: "block" } }}>
				<NavbarDesktop position={position} />
			</Box>
			{
				(isMobile === "false" || isMobile === null) &&
				<Box sx={{ display: { xs: "block", lg: "none" } }}>
					<NavbarMobile position={position} />
				</Box>
			}
		</>
	);
};

export default Navbar;
